import React, { useEffect } from "react";
import Button from "../components/Button";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import {
  detailConsul,
  listConsul,
} from "../redux/actions/honararyConsulAction";
import moment from "moment";
import { Link } from "react-router-dom";
import { url } from "../utils/env";

const HonororyConsulScreen = () => {
  const dispatch = useDispatch();
  const listConsuls = useSelector((state) => state.listConsuls);
  const { consuls } = listConsuls;
  useEffect(() => {
    dispatch(listConsul());
  }, []);
  return (
    <Layout>
      <PageTitle
        title="Honorary Consul"
        description="Honorary Consul Description"
        button="Add New Honorary Consul"
        link="/add-honorory"
      />
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-3">List of Honorary Consul</h4>
          {/* <p class="card-title-desc">
            Add <code>.table-bordered</code> for borders on all sides of the
            table and cells.
          </p> */}

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Date</th>
                  <th>Created At</th>
                  <th>View Detail</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {consuls &&
                  consuls.map((value) => (
                    <tr>
                      <th scope="row">{value.uuid}</th>
                      <td>{value.name}</td>
                      <td>
                        <img
                          src={`${url}/${value.image}`}
                          alt=""
                          style={{
                            width: "30px",
                            height: "30px",
                            border: "2px solid #c3c3c3",
                          }}
                          className="me-2"
                        />
                      </td>
                      <td>{moment(value.joinDate).format("MMMM Do YYYY")}</td>

                      <td>{moment(value.createdAt).format("MMMM Do YYYY")}</td>

                      <td>
                        <Button name="View" icon="fas fa-eye" />
                      </td>
                      <td style={{ width: "100px" }}>
                        <Link
                          to={`/edit-honorory/${value.uuid}`}
                          onClick={() => dispatch(detailConsul(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HonororyConsulScreen;
